import { SVGProps } from 'react';

const UserIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width || '18'}
      height={props?.height || '18'}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M8.99995 9.892C11.4656 9.892 13.4644 7.89315 13.4644 5.42744C13.4644 2.96174 11.4656 0.962891 8.99995 0.962891C6.53431 0.962891 4.53552 2.96174 4.53552 5.42744C4.53552 7.89315 6.53431 9.892 8.99995 9.892Z"
        stroke={props?.fill || '#616161'}
        strokeWidth="1.29"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1431 17.0339C16.1431 15.1394 15.3905 13.3225 14.0509 11.9828C12.7113 10.6432 10.8944 9.89063 8.99998 9.89062C7.10552 9.89063 5.28865 10.6432 3.94906 11.9828C2.60948 13.3225 1.8569 15.1394 1.8569 17.0339"
        stroke={props?.fill || '#616161'}
        strokeWidth="1.29"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UserIcon;
